export default "__VITE_ASSET__C_Irv1VX__"